/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

module.exports = [{
  action: 'getDealLimitByCompositeKey',
  message: messages.SUCCESS_GET_DEAL_LIMIT_BY_COMPOSITE_KEY,
  method: 'GET',
  path: '/deal-limit/:compositeKey',
  payloadType: 'resource',
  permissionIdentity: permissionIdentities.GET_DEAL_LIMIT,
  requestSchema: requestSchemas.dealLimits.getDealLimitByCompositeKey,
}];
